
export const CLIENT_TYPES = {
  DEFAULT: 'DEFAULT',
  DOKTOR_CONNECT: 'DOKTOR_CONNECT',
  ATP: 'ATP',
  HELLO_HEALTH: 'HELLO_HEALTH',
};
export const API_KEYS = {
  [CLIENT_TYPES.DOKTOR_CONNECT]: process.env.REACT_APP_DOKTOR_CONNECT_API_KEY,
  [CLIENT_TYPES.ATP]: process.env.REACT_APP_ATP_LAB_CONNECT_API_KEY,
  [CLIENT_TYPES.HELLO_HEALTH]: process.env.REACT_APP_HELLO_HEALTH_API_KEY,
};